/**
 * @author zgl
 * @description
 */

import { RouteRecordRaw } from "vue-router";

import School from "./shcool/index.vue";
import SchoolHome from "./shcool/home/index.vue";

const basePath = "/";
const baseName = "School";
const schoolHomePath = "home";

export const RoutePath = {
  root: basePath,
  school: basePath + schoolHomePath,
};

export const RouteName = {
  school: baseName,
  schoolHome: baseName + "Home",
};

export const Route: Array<RouteRecordRaw> = [
  {
    path: RoutePath.school,
    name: RouteName.schoolHome,
    component: School,
    children: [
      {
        path: '',
        component: SchoolHome,
      },
    ],
  },
];
